export default {
    "entityName": "pharmacy",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "site_id",
            "text": "Site",
            title: "name",
            subtitle: item => `${item.city} - ${item.code}`,
            "type": "autocomplete",
            filter: (item, search) => {
                if (search) return [{ 'site.name': `%${search}%`}, { 'site.city': `%${search}%`}, { 'site.code': `%${search}%`}]
                return { 'site.id': item.site_id }
            },
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.site.city} - ${item.site.name} (${item.site.code})`,
            "validators": [
                "required"
            ]
        },        
        {
            "value": "email",
            "text": "Email",
            "type": "text",
            "validators": [
                "email"
            ]
        },
        {
            "value": "phone",
            "text": "Phone",
            "type": "text"
        },
        {
            "value": "fax",
            "text": "Fax",
            "type": "text"
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            "table": {
                "sortable": true,
            },
            "validators": [
                "required"
            ],
            render: item => `${item.address}, ${item.city}, ${item.cap} (${item.country})`
        },
        {
            "value": "city",
            "text": "City",
            "type": "text",
            "validators": [
                "required"
            ],
            small: true
        },
        {
            "value": "cap",
            "text": "Cap",
            "type": "text",
            "validators": [
                "required",
            ],
            small: true
        },        
        {
            "value": "country",
            "text": "Country",
            "type": "text",
            "validators": [
                "required",
                (field, value) => value && value.length <= 2 || `Country max. length is 2` 
            ],
            small: true
        },
        {
            full: true,
            "value": "floor",
            "text": "Note",
            "type": "textarea"
        },        
    ],
    "actions": [
        'upsert',
        'remove',
        { "value": "references", "text": "References", "color": "primary", "icon": "mdi-contacts" },
        'audit'
    ]
}